var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginButton"},[_c('img',{attrs:{"src":require("@/assets/img/google-sign-in.png"),"alt":"Sign-in with Google"},on:{"click":_vm.doLogin}})])
}
var staticRenderFns = []

export { render, staticRenderFns }